// src/components/common/Button.jsx
import React from "react";

const variants = {
  primary: [
    "text-white font-semibold",
    "bg-gradient-to-r from-primary-500 to-primary-600",
    "shadow-btn hover:shadow-btn-hover hover:from-primary-600 hover:to-primary-700",
    "disabled:from-primary-300 disabled:to-primary-300 disabled:shadow-none",
  ].join(" "),
  outline: [
    "text-primary-600 font-semibold",
    "border-2 border-primary-300 bg-white/60 backdrop-blur-sm",
    "hover:bg-primary-50 hover:border-primary-400",
    "disabled:opacity-50",
  ].join(" "),
  ghost: [
    "text-primary-600 font-semibold",
    "bg-transparent hover:bg-primary-50",
    "disabled:opacity-50",
  ].join(" "),
  danger: [
    "text-white font-semibold",
    "bg-gradient-to-r from-red-500 to-red-600",
    "hover:from-red-600 hover:to-red-700",
    "disabled:opacity-50",
  ].join(" "),
};

const sizes = {
  sm:  "py-2 px-4 text-xs rounded-lg",
  md:  "py-3 px-6 text-sm rounded-xl",
  lg:  "py-3.5 px-8 text-base rounded-xl",
  xl:  "py-4 px-10 text-base rounded-2xl",
};

const Button = ({
  children,
  variant = "primary",
  size = "md",
  fullWidth = false,
  loading = false,
  disabled = false,
  type = "button",
  onClick,
  className = "",
  id,
}) => {
  return (
    <button
      id={id}
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={[
        "inline-flex items-center justify-center gap-2",
        "tracking-wide transition-all duration-300 active:scale-[0.98]",
        "cursor-pointer select-none",
        variants[variant] || variants.primary,
        sizes[size] || sizes.md,
        fullWidth ? "w-full" : "",
        (disabled || loading) ? "cursor-not-allowed" : "",
        className,
      ].join(" ")}
    >
      {loading && (
        <svg
          className="animate-spin"
          width="16" height="16" fill="none"
          viewBox="0 0 24 24"
        >
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      )}
      {children}
    </button>
  );
};

export default Button;
